import React, { Fragment } from 'react';
import './styles.styl';

const Footer = ({ data }) => {
  const getYear = () => {
    return new Date().getFullYear();
  };

  return (
    <Fragment>
      <div className="footer">
        <div className="footer__logo-wrapper">
          <img src={data.leftLogo.image} alt={data.leftLogo.altText} />
        </div>
        <p className="footer__copyright">
          &copy; {getYear()} All rights reserved.
        </p>
        <div className="footer__logo-wrapper">
          <img src={data.rightLogo.image} alt={data.rightLogo.altText} />
        </div>
      </div>
    </Fragment>
  );
};

export default Footer;



// WEBPACK FOOTER //
// ../core/src/components/Footer/Footer.js